import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { phone_number } from '../../tools/phone-number';

@Component({
  selector: 'ap-phone-dialog',
  templateUrl: './phone.dialog.html',
  styleUrls: ['./phone.dialog.scss']
})
export class PhoneDialogComponent {
  readonly callUri: string;
  message = '';
  private readonly smsBaseUri: string;

  get smsUri(): string {
    return this.message ? `${this.smsBaseUri}?body=${encodeURIComponent(this.message)}` : this.smsBaseUri;
  }

  constructor(@Inject(MAT_DIALOG_DATA) public phone: string) {
    const number = phone_number(phone);
    const dialNumber = number.startsWith('0') ? '+61' + number.substring(1) : number;
    this.callUri = `tel:${dialNumber}`;
    this.smsBaseUri = `sms:${dialNumber}`;
  }
}
